/**
 * Session-cookie based "clear on browser close" for auth storage.
 * If the session cookie is missing on app load, clear session-scoped keys from
 * sessionStorage and localStorage. Preserves arcm_trust_browser_token, LogoutfromAllTabs.
 */

// Session cookie: no Max-Age/Expires => dropped when browser closes
const SESSION_COOKIE_NAME = 'arcm_browser_session';

const getSessionCookie = () => {
    if (typeof document === 'undefined' || !document.cookie) return false;
    return document.cookie.split(';').some((part) =>
        part.trim().startsWith(SESSION_COOKIE_NAME + '=')
    );
};

const setSessionCookie = () => {
    if (typeof document === 'undefined') return;
    try {
        document.cookie = `${SESSION_COOKIE_NAME}=1; path=/; SameSite=Lax`;
    } catch (error) {
        console.error('Error setting session cookie:', error);
    }
};

export const clearSessionCookie = () => {
    if (typeof document === 'undefined') return;
    try {
        document.cookie = `${SESSION_COOKIE_NAME}=; path=/; Max-Age=0`;
    } catch (error) {
        console.error('Error clearing session cookie:', error);
    }
};

// Keys to clear when browser was closed and reopened (auth/session data only)
const SESSION_SCOPED_KEYS = [
    'IdToken',
    'RefreshToken',
    'AccessToken',
    'email',
    'user_id',
    'id',
    'user_type',
    'session_token',
    'custom:is_first_time_login',
    'user-info',
    'browser_trust_duration',
    'custom-status',
    'verify_otp_session_token',
    'preference_id',
    'token',
    'currentTimestamp',
    'first_name',
    'last_name',
    'duration',
    'restrict',
    'org_id',
];

/**
 * Call once before the app renders. If the session cookie is missing
 * (browser was closed and reopened), clear session-scoped keys from both
 * storages. Then set the cookie so refreshes do not clear. Preserves
 * arcm_trust_browser_token and LogoutfromAllTabs.
 */
export const clearStorageIfNewBrowserSession = () => {
    if (typeof window === 'undefined' || !window.localStorage) return;
    if (getSessionCookie()) return;

    try {
        SESSION_SCOPED_KEYS.forEach((key) => {
            window.sessionStorage.removeItem(key);
            window.localStorage.removeItem(key);
        });
    } catch (error) {
        console.error('Error clearing session-scoped storage:', error);
    }
    setSessionCookie();
};

export { setSessionCookie };
